module.exports = __webpack_public_path__ + "media/images/project/due-date-2080bf1073b89b672b203654739f1832.svg";